@if (_currentData.id == undefined) {
  <pdf-viewer [config]="_currentData" [isBlob]="_currentData.isBlob"></pdf-viewer>
}
@if (_currentData.showDoc === true) {
  @if (_currentData.contentType == 'application/pdf') {
    <pdf-viewer [config]="_currentData"></pdf-viewer>
  } @else {
    <app-image-viewer style="width: 100%; height:600px" [config]="{'allowDownload': false}" [src]="_currentData.imageSrc" [fileData]="_currentData.fileData">
    </app-image-viewer>
  }
}
